<template>
  <section class="find-password">
    <auth-layout name="find-password">
      <template #body>
        <div class="title">
          <h3 v-text="`SMART SOLUTION ${$t('find_pw')}`"></h3>
          <p v-text="$t('common.t_id_find_desc')"></p>
        </div>
        <div class="content">
          <form @submit.prevent="formSubmit">
            <fieldset>
              <legend v-text="$t('select_user_type')"></legend>
              <dl class="inline">
                <dt v-text="$t('type')"></dt>
                <dd>
                  <select v-model="roleCode">
                    <option value="12001" v-text="$t('personal_user')"></option>
                    <option
                      value="12002"
                      v-text="$t('business_and_group_user')"
                    ></option>
                    <option value="12003" v-text="$t('manager_user')"></option>
                  </select>
                </dd>
              </dl>
              <legend v-text="$t('insert_name_and_phone_and_id')"></legend>
              <dl class="inline">
                <dt v-text="$t('common.t_name')"></dt>
                <dd class="block">
                  <input
                    id="name"
                    v-model="name"
                    type="text"
                    :class="{ error: errorNameMessage }"
                    :placeholder="$t('common.t_name')"
                  />
                  <p class="error-message" v-html="errorNameMessage"></p>
                </dd>
              </dl>
              <dl class="inline">
                <dt v-text="$t('id_and_pw')"></dt>
                <dd class="block">
                  <input
                    id="email"
                    v-model="email"
                    type="email"
                    :class="{ error: errorEmailMessage }"
                    :placeholder="$t('id_and_pw')"
                  />
                  <p class="error-message" v-html="errorEmailMessage"></p>
                </dd>
              </dl>
              <dl class="inline">
                <dt v-text="$t('phone')"></dt>
                <dd class="block">
                  <input
                    id="telno"
                    v-model="telno"
                    type="number"
                    :class="{ error: errorPhoneMessage }"
                    :placeholder="$t('phone_desc')"
                  />
                  <p class="error-message" v-html="errorPhoneMessage"></p>
                </dd>
              </dl>
            </fieldset>
            <div class="button-box">
              <Button
                type="submit"
                name="find-password"
                class="primary"
                :value="$t('common.t_imsi_send')"
              />
            </div>
          </form>
        </div>
      </template>
    </auth-layout>
  </section>
</template>

<script>
import { Common } from '@src/common';
import eve from '@src/commonEvent';
import { findPassword } from '@api/auth';
import authLayout from '@layouts/authLayout.vue';
import Button from '@components/Button.vue';
import { getLanguage } from '@action/util';

export default {
  name: 'findPassword',
  components: {
    authLayout,
    Button,
  },
  head: {
    title: {
      inner: 'Find Password',
      separator: '|',
      complement: 'Smart Solution',
    },
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Find Your Password - Smart Solution',
      },
    ],
  },
  data() {
    return {
      lang: 'ko',
      roleCode: '12001',
      email: '',
      name: '',
      telno: '',
      errorNameMessage: '',
      errorEmailMessage: '',
      errorPhoneMessage: '',
    };
  },
  created() {
    this.lang = getLanguage();
  },
  methods: {
    checkForm() {
      this.errorNameMessage = '';
      this.errorEmailMessage = '';
      this.errorPhoneMessage = '';

      if (!this.name) {
        this.errorNameMessage = eve.Lang.t('common.d_input_name');
        document.getElementById('name').focus();
        return false;
      }

      if (!this.email) {
        this.errorEmailMessage = eve.Lang.t('common.t_msg_insert_email');
        document.getElementById('email').focus();
        return false;
      }

      if (!this.telno) {
        this.errorPhoneMessage = eve.Lang.t('common.t_confirm_phone');
        document.getElementById('telno').focus();
        return false;
      }

      return true;
    },

    async formSubmit() {
      if (!this.checkForm()) return;

      const { data } = await findPassword({
        email: this.email,
        name: this.name,
        telno: this.telno,
        role_code: this.roleCode,
        lang: this.lang === 'ja' ? 'jp' : this.lang,
      });

      if (data.code === Common.CODE_OK) {
        alert(eve.Lang.t('common.d_input_mail'));
      } else {
        alert(data.message);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.find-password {
  p.error-message {
    margin-top: 8px;
    color: $invalid;
  }

  .title {
    padding: 18px 0;
    border-bottom: 1px solid $gray-e6;

    h3 {
      font-size: 14px;
      text-align: center;
    }

    p {
      margin-top: 6px;
      font-size: 12px;
      color: $gray-48;
      text-align: center;
    }
  }

  .content {
    padding: 16px 0;

    fieldset {
      margin: 8px 0;

      & + fieldset {
        margin-top: 24px;
      }

      legend {
        margin-top: 8px;
        margin-bottom: 8px;
        color: $gray-48;

        &:first-child {
          margin-bottom: 8px;
          color: $gray-48;
        }
      }

      dl {
        padding: 8px 0;

        dt {
          width: 100px;
          min-width: 100px;
          font-size: 12px;
          color: $gray-88;
        }

        dd {
          width: 100%;
          font-size: 12px;
        }
      }

      .button-box {
        display: flex;
        width: 100%;
        padding: 12px 0;
      }
    }
  }
}
</style>
